const ChevronThinRight = () => (
    <svg width="12" height="24" viewBox="0 0 12 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1l10 11L1 23" stroke="currentColor" strokeWidth="1.4" strokeLinecap="square" />
    </svg>
)

export default ChevronThinRight;
